// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const payments = {
  id: "additional",
  title: "More",
  type: "group",
  children: [
    {
      id: "payments",
      title: "Payments",
      type: "item",
      url: "/payments",
    },
    {
      id: "payment-methods",
      title: "Payment Methods",
      type: "item",
      url: "/payments/methods",
    },
    {
      id: "settings",
      title: "Settings",
      type: "item",
      url: "/settings",
    },
    {
      id: "contracts",
      title: "Contracts",
      type: "item",
      url: "/contracts",
    },
  ],
};

export default payments;
